import React from 'react';
import {useState, useEffect, useRef, useLayoutEffect} from 'react';
import {useLocation, useNavigate, useSearchParams} from 'react-router-dom';

import './App.css';
import './output.css';

import github_logo from "./logo/github.png";
import taobao_logo from "./logo/taobao.png";
import douyin_logo from "./logo/tiktok.png";

import sharedVariable from './global_v';

var current_page = 0;
var current_page2 = 0;

var temp_tip_amount = 0;

// 防止频繁refresh
var last_refresh_time = 0;

var last_change_page_time = 0;

var user_info = [];

function Analyse_user_info(temp_user_info){
  if (temp_user_info.index === 1){
    return(
      <div>
        <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
          <div className='flex'>
            <div style={{marginLeft:'1rem', width:'3rem', minWidth:'3rem', height:'2rem'}} className='relative'>
              <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#FFD700'}} className='relative grid place-content-center'>
                <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                  <div style={{right:'0.05rem', top:'0.1rem', color:'#FFD700'}} className='relative'>
                    {temp_user_info.index}
                  </div>  
                </div> 
              </div>
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
              uid:{temp_user_info.uid}
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
              昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
            </div>          
          </div>      
        </div>
        <div style={{height:'3rem'}} className='bg-amber-200'>
          <div style={{paddingTop:'0.25rem', marginLeft:'5rem'}}>
            累计打赏的金额:{temp_user_info.amount}元
          </div>
        </div>  
      </div>
    )
  }
  if (temp_user_info.index === 2){
    return(
      <div>
        <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex'>
          <div className='flex'>
            <div style={{marginLeft:'1rem', width:'3rem', minWidth:'3rem', height:'2rem'}} className='relative'>
              <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#c0c0c0'}} className='relative grid place-content-center'>
                <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                  <div style={{right:'0.05rem', top:'0.1rem', color:'#c0c0c0'}} className='relative'>
                    {temp_user_info.index}
                  </div>  
                </div> 
              </div>
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
              uid:{temp_user_info.uid}
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
              昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
            </div> 
          </div>   
        </div>        
        <div style={{height:'3rem'}}>
          <div style={{paddingTop:'0.25rem', marginLeft:'5rem'}}>
            累计打赏的金额:{temp_user_info.amount}元
          </div>
        </div>         
      </div>
    )    
  }
  if (temp_user_info.index === 3){ 
    return(
      <div>
        <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
          <div className='flex'>
            <div style={{marginLeft:'1rem', width:'3rem', minWidth:'3rem', height:'2rem'}} className='relative'>
              <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#D98719'}} className='relative grid place-content-center'>
                <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                  <div style={{right:'0.05rem', top:'0.1rem', color:'#D98719'}} className='relative'>
                    {temp_user_info.index}
                  </div>  
                </div> 
              </div>
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
              uid:{temp_user_info.uid}
            </div>
            <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
              昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
            </div> 
          </div>    
        </div>          
        <div style={{height:'3rem'}} className='bg-amber-200'>
          <div style={{paddingTop:'0.25rem', marginLeft:'5rem'}}>
            累计打赏的金额:{temp_user_info.amount}元
          </div>
        </div>          
      </div> 
    )
  }
  if (temp_user_info.index > 3){
    if (temp_user_info.index % 2 === 0){
      if (temp_user_info.index < 10){
        return(
          <div>
            <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex'>
              <div className='flex'>
                <div style={{marginLeft:'1rem', width:'3rem', minWidth:'3rem', height:'2rem'}} className='relative'>
                  <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                    <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                      <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                        {temp_user_info.index}
                      </div>  
                    </div> 
                  </div>
                </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
                uid:{temp_user_info.uid}
              </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
                昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
              </div> 
              </div>  
            </div>               
            <div style={{height:'3rem'}}>
              <div style={{paddingTop:'0.25rem', marginLeft:'5rem'}}>
                累计打赏的金额:{temp_user_info.amount}元
              </div>
            </div>             
          </div>
        )
      }
      else{
        return(
          <div>
            <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex'>
              <div className='flex'>
                <div style={{marginLeft:'1rem', width:'3rem', minWidth:'3rem', height:'2rem'}} className='relative'>
                  <div style={{top:'0.5rem', width:'2.5rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                    <div style={{width:'2rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                      <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                        {temp_user_info.index}
                      </div>  
                    </div> 
                  </div>
                </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
                uid:{temp_user_info.uid}
              </div>
              <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
                昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
              </div> 
              </div>       
            </div>               
            <div style={{height:'3rem'}}>
              <div style={{paddingTop:'0.25rem', marginLeft:'5rem'}}>
                累计打赏的金额:{temp_user_info.amount}元
              </div>
            </div>            
          </div>
        )        
      }
    }
    else{
      if (temp_user_info.index < 10){
        return(
          <div>
            <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
              <div className='flex'>
                <div style={{marginLeft:'1rem', width:'3rem', minWidth:'3rem', height:'2rem'}} className='relative'>
                  <div style={{top:'0.5rem', width:'2rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                    <div style={{width:'1.5rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                      <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                        {temp_user_info.index}
                      </div>  
                    </div> 
                  </div>
                </div>
                <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
                  uid:{temp_user_info.uid}
                </div>
                <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
                  昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
                </div> 
              </div>   
            </div>             
            <div style={{height:'3rem'}} className='bg-amber-200'>
              <div style={{paddingTop:'0.25rem', marginLeft:'5rem'}}>
                累计打赏的金额:{temp_user_info.amount}元
              </div>
            </div>             
          </div>  
        )
      }
      else{
        return(
          <div>
            <div style={{width:'100%', paddingBottom:'0.25rem'}} className='flex bg-amber-200'>
              <div className='flex'>
                <div style={{marginLeft:'1rem', width:'3rem', minWidth:'3rem', height:'2rem'}} className='relative'>
                  <div style={{top:'0.5rem', width:'2.5rem', height:'2rem', minWidth:'2rem', minHeight:'2rem', borderRadius:'5rem', backgroundColor:'#43464b'}} className='relative grid place-content-center'>
                    <div style={{width:'2rem', height:'1.5rem', minWidth:'1.5rem', minHeight:'1.5rem', borderRadius:'5rem'}} className='bg-amber-50 grid place-content-center'>
                      <div style={{right:'0.05rem', top:'0.1rem', color:'#43464b'}} className='relative'>
                        {temp_user_info.index}
                      </div>  
                    </div> 
                  </div>
                </div>
                <div style={{marginLeft:'1rem', marginTop:'0.5rem', minWidth:'10rem'}}>
                  uid:{temp_user_info.uid}
                </div>
                <div style={{marginLeft:'1rem', marginTop:'0.5rem'}}>
                  昵称:{temp_user_info.nickname?temp_user_info.nickname:'匿名用户'}
                </div> 
              </div>     
            </div>              
            <div style={{height:'3rem'}} className='bg-amber-200'>
              <div style={{paddingTop:'0.25rem', marginLeft:'5rem'}}>
                累计打赏的金额:{temp_user_info.amount}元
              </div>
            </div>             
          </div> 
        )        
      }
    }
  }
}

const Home = () => {
  const temp_count = useRef(0);

  const navigate = useNavigate();

  const [changeClass, setChangeClass] = useState(false);

  const [page, set_page] = useState(current_page);
  const [page2, set_page2] = useState(current_page2);

  if (temp_count.current === 0){
    temp_count.current = 1;
    if (page === 0){
      setTimeout(() => {
        setChangeClass(true);
      }, 100);
    }

    if (page === 1){
      //var temp_url = 'http://localhost:5001/api/get_supporter_list'
      var temp_url = 'https://bailanjo.cn/api/get_supporter_list';

      fetch(temp_url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json(); // 或者 response.text() 根据你的需要
        })
        .then(data => {
          // 处理返回的数据
          if (data){
            // 不要重新var！
            user_info = [];
            var temp_index = 1;

            data.result.forEach(temp_result => {
              var temp_uid = temp_result.uid;

              var temp_length = temp_uid.toString().length;
              if (temp_length <= 8){
                for(let i = 0;i < 8 - temp_length; i++){
                  temp_uid = '0' + temp_uid;
                }
              }

              user_info.push({'index':temp_index, 'username':temp_result.username, 'uid':temp_uid, 'nickname':temp_result.nickname, 'amount':temp_result.total_amount})
              temp_index += 1;
            });

            set_page2(0);

            setTimeout(() => {           
              setChangeClass(true);             
            }, 100);              
          }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });      
    }    
  }

  function change_page(){
    if (Math.floor(new Date().getTime() / 1000) - last_change_page_time > 1){
      last_change_page_time = Math.floor(new Date().getTime() / 1000);

      setChangeClass(false);

      current_page += 1;
      if (current_page >= 2){
        current_page = 0;
      }
      
      if (current_page === 0){
        setTimeout(() => {
          setChangeClass(true);
        }, 100);
      }

      if (current_page === 1){
        //var temp_url = 'http://localhost:5001/api/get_supporter_list'
        var temp_url = 'https://bailanjo.cn/api/get_supporter_list';

        fetch(temp_url)
          .then(response => {
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              return response.json(); // 或者 response.text() 根据你的需要
          })
          .then(data => {
            // 处理返回的数据
            if (data){
              // 不要重新var！
              user_info = [];
              var temp_index = 1;

              data.result.forEach(temp_result => {
                var temp_uid = temp_result.uid;

                var temp_length = temp_uid.toString().length;
                if (temp_length <= 8){
                  for(let i = 0;i < 8 - temp_length; i++){
                    temp_uid = '0' + temp_uid;
                  }
                }

                user_info.push({'index':temp_index, 'username':temp_result.username, 'uid':temp_uid, 'nickname':temp_result.nickname, 'amount':temp_result.total_amount})
                temp_index += 1;
              });

              set_page2(0);

              setTimeout(() => {           
                setChangeClass(true);             
              }, 100);              
            }
          })
          .catch(error => {
              console.error('There was a problem with the fetch operation:', error);
          });       
      }

      set_page(current_page);      
    }
    else{
      alert('切换页面过于频繁！')
    }  
  }

  function go_to_github(){
    window.open('https://github.com/zhouajiew', '_blank', 'noopener,noreferrer');
  }

  function go_to_taobao(){
    window.open('https://bailanjo.taobao.com/', '_blank', 'noopener,noreferrer');
  }

  function go_to_douyin(){
    window.open('https://www.douyin.com/user/MS4wLjABAAAAdOqW8qnjARxtmdrU1bqyQvMK60HT6femFabNNpsj_Dq-oEw2wMDPFEr6k5Mi291R?from_tab_name=main', '_blank', 'noopener,noreferrer');
  }

  const update_tip_amount= (event) => {
    temp_tip_amount = event.target.value;
  }

  function tip_author(){
    var temp_int = parseInt(temp_tip_amount);

    if (Number.isNaN(temp_int)){
      alert('打赏金额不为数字！')
    }
    else{
      if (temp_tip_amount <= 0){
        alert('打赏金额不能<=0元！')
      }
      else if (temp_tip_amount > 648){
        alert('打赏金额过大！')
      }
      else {
        if (sharedVariable.tip_username !== '' && sharedVariable.login_status){
          navigate(`/tip?username=${sharedVariable.tip_username}&amount=${temp_tip_amount}`);
        }
        else{
          alert('请先登录后再打赏作者喔')
        }
      }
    }
  }

  function refresh(){
    if (Math.floor(new Date().getTime() / 1000) - last_refresh_time > 1){
      last_refresh_time = Math.floor(new Date().getTime() / 1000);

      current_page2 = 0;

      navigate('/blank');
      setTimeout(() => {
        navigate('/');
      }, 10);    
    }           
    else{
      alert('刷新过于频繁！');
    }  
  }

  function change_page2_1(){
    current_page2 -= 1;
    if (current_page2 < 0){
      if (user_info.length % 4 === 0){
        current_page2 = user_info.length / 4 - 1;
      }
      else{
        current_page2 = Math.ceil(user_info.length / 4) - 1;
      }
    }
    set_page2(current_page2); 
  }

  function change_page2_2(){
    current_page2 += 1;
    if (user_info.length % 4 === 0){
      if (current_page2 > user_info.length / 4 - 1){
        current_page2 = 0;
      }
    }
    else{
      if (current_page2 > Math.ceil(user_info.length / 4 - 1)){
        current_page2 = 0;
      }
    }
    set_page2(current_page2);
  }

  if (page === 0){
    return(
      <div style={{minHeight:'calc(100lvh - 4rem)', minWidth:'76rem'}} className="z-10 w-full bg-amber-50">
        <div style={!changeClass ? {width:'100%', height:'5rem'} : {width:'100%', height:'5rem', transition:'opacity 1s ease'}} className={!changeClass ? "opacity-0" : "opacity-100"}>
          <div style={{top:'2rem'}} className='relative'>
            <div onClick={change_page} style={{marginLeft:'2.5rem', width:'3rem', height:'3rem', borderRadius:'5rem', cursor:'pointer'}} className='bg-amber-400 grid place-content-center'>
              <div style={{width:'2.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                <div style={{fontFamily:'Hello Headline, lyt', marginLeft:'0.125rem', fontSize:'1.75rem'}}>
                  {">"}
                </div>
              </div>
            </div>    
          </div>
        </div>    
        <div style={ !changeClass ? {} : {transition:'opacity 1s ease'}} className={!changeClass ? "opacity-0 grid text-center place-content-center" : "opacity-100 grid text-center place-content-center"}>      
          <div style={{minHeight:'calc(100lvh - 17rem)'}} className="grid text-center place-content-center">
            <div style={{top:'-2.5rem'}} className='relative'>
              <div className='font1'> 
                  Hey&nbsp;&nbsp;mate!
              </div>
              <div className='font1'>
                  Nice&nbsp;&nbsp;to&nbsp;&nbsp;meet&nbsp;&nbsp;ya:D
              </div>  
            </div>        
          </div>
          <div style={{height:'4rem', fontFamily:'Hello Headline, lyt', fontSize:'20px', color:'#282c34'}} className="grid place-content-center">
            <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2025211998号</a>
          </div>
          <div style={{height:'4rem', fontFamily:'Hello Headline, lyt', fontSize:'20px', color:'#282c34'}} className="grid place-content-center">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33030302251201" target="_blank">浙公网安备33030302251201号</a>
          </div>
        </div>
      </div> 
    )
  }
  if (page === 1){
    return(
      <div style={{minHeight:'calc(100lvh - 4rem)', minWidth:'76rem'}} className="z-10 w-full bg-amber-50">
        <div style={ !changeClass ? {} : {transition:'opacity 1s ease'}} className={!changeClass ? "flex opacity-0" : "flex opacity-100"}>
          <div style={{width:'6rem', minWidth:'6rem', height:'5rem'}}>
            <div style={{top:'2rem'}} className='relative'>
              <div onClick={change_page} style={{marginLeft:'2.5rem', width:'3rem', height:'3rem', borderRadius:'5rem', cursor:'pointer'}} className='bg-amber-400 grid place-content-center'>
                <div style={{width:'2.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                  <div style={{fontFamily:'Hello Headline, lyt', marginLeft:'0.125rem', fontSize:'1.75rem'}}>
                    {">"}
                  </div>
                </div>
              </div>    
            </div>
          </div>
          <div style={{width:'30rem', minWidth:'30rem'}}>
            <div className='flex'>
              <img alt='github' onClick={go_to_github} style={{marginTop:'1.5rem', marginLeft:'6rem', width:'4rem', cursor:'pointer'}} src={github_logo}>
              </img>            
              <div onClick={go_to_github} style={{marginLeft:'1rem', marginTop:'2.5rem', fontFamily:'Hello Headline, lyt', fontSize:'24px', cursor:'pointer'}}>
                zhouajiew
              </div>
              </div>   
              <div className='flex'>
                <img alt='taobao' onClick={go_to_taobao} style={{marginTop:'1.5rem', marginLeft:'6rem', height:'4rem', width:'4rem', cursor:'pointer'}} src={taobao_logo}>
                </img>            
                <div onClick={go_to_taobao} style={{marginLeft:'1rem', marginTop:'2.5rem', fontFamily:'Hello Headline, lyt', fontSize:'24px', cursor:'pointer'}}>
                  摆烂Jo的小店
                </div>
              </div>     
              <div className='flex'>
                <img alt='douyin' onClick={go_to_douyin} style={{marginTop:'1.5rem', marginLeft:'6rem', height:'4rem', width:'4rem', cursor:'pointer'}} src={douyin_logo}>
                </img>            
                <div onClick={go_to_douyin} style={{marginLeft:'1rem', marginTop:'2.5rem', fontFamily:'Hello Headline, lyt', fontSize:'24px', cursor:'pointer'}}>
                  摆烂Jo
                </div>
              </div>                                   
            </div>
          <div style={{width:'30rem', minWidth:'40rem', minHeight:'calc(100lvh - 4rem)'}} className='bg-amber-50'>
            <div style={{marginTop:'2rem', fontFamily:'Hello Headline, lyt', fontSize:'24px'}}>
              请作者喝一杯奶茶:D
            </div>
            <div className='flex'>
              <div style={{marginTop:'2rem', height:'3rem', width:'10rem'}} className="bg-amber-200">
                <input onChange={update_tip_amount} style={{height:'3rem', width:'9rem', marginLeft: '0.5rem', fontFamily: 'Hello Headline, lyt'}} placeholder="在此填写打赏金额:)" className="focus:outline-0">
                </input>
              </div>
              <div onClick={tip_author} style={{marginLeft: '0.5rem', marginTop:'2rem', height:'3rem', width:'6rem', borderRadius: '5rem', cursor:"pointer", transition:'background-color 1s ease'}} className="bg-amber-200 text-center place-content-center grid hover:bg-amber-400 active:bg-amber-600">
                <div style={{fontFamily: 'Hello Headline, lyt', fontSize:'20px'}}>
                  打赏
                </div>
              </div>  
            </div>
            <div style={{fontFamily:'Hello Headline, lyt'}} className='flex'>
              <div onClick={refresh} style={{top:'2rem', cursor:'pointer'}} className='relative'>
                <div style={{width:'6rem', height:'3rem', borderRadius:'5rem'}} className='bg-amber-400 grid place-content-center'>
                  <div style={{width:'5.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                    <div style={{marginRight:'0.1rem', fontSize:'1.2rem'}}>
                      刷新
                    </div>
                  </div>
                </div>
              </div>                  
              <div onClick={change_page2_1} style={{left:'2rem', top:'2rem', cursor:'pointer'}} className='relative'>
                <div style={{width:'3rem', height:'3rem', borderRadius:'5rem'}} className='bg-amber-400 grid place-content-center'>
                  <div style={{width:'2.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                    <div style={{marginRight:'0.125rem', fontSize:'1.75rem'}}>
                      {"<"}
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={change_page2_2} style={{left:'4rem', top:'2rem', cursor:'pointer'}} className='relative'>
                <div style={{width:'3rem', height:'3rem', borderRadius:'5rem'}} className='bg-amber-400 grid place-content-center'>
                  <div style={{width:'2.5rem', height:'2.5rem', borderRadius:'5rem', color:'oklch(82.8% 0.189 84.429)'}} className='bg-amber-200 grid place-content-center'>
                    <div style={{marginLeft:'0.125rem', fontSize:'1.75rem'}}>
                      {">"}
                    </div>
                  </div>
                </div>
              </div> 
            </div> 
            <div style={{marginTop:'3rem', fontFamily:'Hello Headline, lyt'}}>
              {
                user_info.map((temp_user_info) => {
                  if (temp_user_info.index - 1 >= page2 * 4 && temp_user_info.index - 1 < (page2 + 1) * 4){
                    return(
                      <div style={{fontSize:'24px'}} key={Math.random().toString(36).substring(2, 9)}>
                        {Analyse_user_info(temp_user_info)}
                      </div>  
                    )
                  }
                })  
              }        
            </div>                     
          </div>         
        </div>     
      </div>  
    )
  }
};

export default Home;

// npm install qrcode.react --save            